// extracted by mini-css-extract-plugin
export const container = "Result-module--container--1Y4H2";
export const content = "Result-module--content--1LDyS";
export const title = "Result-module--title--CxUn7";
export const body = "Result-module--body--3ipoY";
export const match = "Result-module--match--Kt3X2";